/* eslint-disable @next/next/no-img-element */
import useLocalizedString from 'helpers/hooks/useLocalizedString';
import { TechnologyImage as TechonologyImageType } from './types';

type Props = {
  image?: TechonologyImageType;
};

const TechnologyImage: React.FC<Props & React.ComponentProps<'img'>> = ({ image, ...props }) => {
  const { formatString } = useLocalizedString();

  if (!image) return null;

  return <img src={image.src} alt={formatString(image.altText)} {...props} />;
};

export default TechnologyImage;
